import axios from "axios";
import Position from "../types/Position";
import Skill from "../types/Skill";
import Course from "../types/Course";
import AllDefinitions from "../types/Definitions";

const API_URL = process.env.REACT_APP_API_URL;

export const getAllPositions = async () => {
  const response = await axios.get(`${API_URL}/all-positions`, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });

  return response.data;
};

export const deletePosition = async (positionId: string) => {
  const response = await axios.post(
    `${API_URL}/delete-position `,
    { positionId },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const updatePosition = async (position: Position) => {
  const response = await axios.post(
    `${API_URL}/update-position `,
    {
      position,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const addNewPosition = async (position: Position) => {
  const response = await axios.post(
    `${API_URL}/update-position `,
    {
      position,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const getAllCourses = async () => {
  const response = await axios.get(`${API_URL}/all-courses`, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });

  return response.data;
};

export const deleteCourse = async (courseId: string) => {
  const response = await axios.post(
    `${API_URL}/delete-course `,
    { courseId },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const updateCourse = async (course: Course) => {
  const response = await axios.post(
    `${API_URL}/update-course `,
    { course },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const addNewCourse = async (course: Course) => {
  const response = await axios.post(
    `${API_URL}/update-course `,
    {
      course,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const getAllSkills = async () => {
  const response = await axios.get(`${API_URL}/all-skills`, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });

  return response.data;
};

export const deleteSkill = async (skillId: string) => {
  const response = await axios.post(
    `${API_URL}/delete-skill `,
    { skillId },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const updateSkill = async (skill: Skill) => {
  const response = await axios.post(
    `${API_URL}/update-skill `,
    {
      skill,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const addNewSkill = async (skill: Skill) => {
  const response = await axios.post(
    `${API_URL}/update-skill `,
    {
      skill,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const getAllDefinitions = async (): Promise<AllDefinitions> => {
  const response = await axios.get(`${API_URL}/all-definitions`, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });

  return response.data;
};
